import { fetchApi } from '../lib/api-client'

export interface Script {
  version: string
  content?: string
  active: boolean
  updatedAt: string
  key?: string
  size?: number
}

export interface CreateScriptRequest {
  version: string
  content: string
  active?: boolean
}

export interface UpdateScriptRequest {
  content: string
  active?: boolean
}

export const scriptsService = {
  async list(): Promise<{ scripts: Script[] }> {
    return fetchApi('/scripts')
  },

  async get(version: string): Promise<{ script: Script }> {
    return fetchApi(`/scripts/${version}/content`)
  },

  async create(data: CreateScriptRequest): Promise<{ script: Script }> {
    return fetchApi('/scripts', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  async update(version: string, data: UpdateScriptRequest): Promise<{ script: Script }> {
    return fetchApi(`/scripts/${version}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  },

  async download(version: string): Promise<Blob> {
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/scripts/${version}/download`, {
      headers: {
        Authorization: `Bearer ${await import('../services/cognito-auth.service').then(m => m.cognitoAuthService.getToken())}`,
      },
    })
    if (!response.ok) {
      throw new Error('Failed to download script')
    }
    return response.blob()
  },
}
